import { render } from "./PoliticallyExposedOnboarding.vue?vue&type=template&id=7cf6d01a&scoped=true&ts=true"
import script from "./PoliticallyExposedOnboarding.vue?vue&type=script&lang=ts"
export * from "./PoliticallyExposedOnboarding.vue?vue&type=script&lang=ts"

import "./PoliticallyExposedOnboarding.vue?vue&type=style&index=0&id=7cf6d01a&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf6d01a"]])

export default __exports__